import { FC, memo } from 'react'

import { FilterGroupHeader } from 'components'
import FilterGroupForDatesProvider from './contexts/Provider'
import FilterGroupForDatesContent from './Content'
import SelectedFilterDateValue from './components/SelectedFilterDateValue'
import { SubmitedFilterDates } from 'components/miscellaneous/CalendarFilter'

type Props = {
  title: string
  description: string
  onSubmitFilter: (values: SubmitedFilterDates) => void
}

const FilterGroupByDate: FC<Props> = ({ title, description, onSubmitFilter }) => {
  return (
    <FilterGroupForDatesProvider onSubmitFilter={onSubmitFilter}>
      <FilterGroupHeader
        title={title}
        description={description}
        shouldOpen={false}
        contentWhenAccordionIsClose={<SelectedFilterDateValue />}
        content={<FilterGroupForDatesContent />}
      />
    </FilterGroupForDatesProvider>
  )
}

export default memo(FilterGroupByDate)
